import { render, staticRenderFns } from "./SubscriptionPage.vue?vue&type=template&id=bf564c1c&"
import script from "./SubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports